import axios from 'axios';

// Attach Authorization header from localStorage for all requests
axios.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        if (!config.headers) config.headers = {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      // Attach X-User-Activity if user was active recently
      const lastActive = Number(localStorage.getItem('last_active_at') || 0);
      if (lastActive && (Date.now() - lastActive < 60000)) {
        if (!config.headers) config.headers = {};
        if (!config.headers['X-User-Activity'] && !config.headers['x-user-activity']) {
          config.headers['X-User-Activity'] = '1';
        }
      }
      try {
        const skip = config && (config.skipLoading === true || (config.headers && (config.headers['X-Skip-Loading'] === '1' || config.headers['x-skip-loading'] === '1')));
        if (!skip) window.dispatchEvent(new CustomEvent('app-loading', { detail: { type: 'start' } }));
      } catch (e) { }
    } catch (e) {
      // ignore
    }
    return config;
  },
  (err) => Promise.reject(err)
);

// Only session-validation requests may force a logout. A page API returning 401
// should be handled by that page without destroying the restored session.
axios.interceptors.response.use(
  // (response) => response,
  (response) => {
    try {
      const cfg = response && response.config;
      const skip = cfg && (cfg.skipLoading === true || (cfg.headers && (cfg.headers['X-Skip-Loading'] === '1' || cfg.headers['x-skip-loading'] === '1')));
      if (!skip) window.dispatchEvent(new CustomEvent('app-loading', { detail: { type: 'end' } }));
    } catch (e) { }
    return response;
  },
  (error) => {
    const cfg = error && error.config;
    try {
      const skip = cfg && (cfg.skipLoading === true || (cfg.headers && (cfg.headers['X-Skip-Loading'] === '1' || cfg.headers['x-skip-loading'] === '1')));
      if (!skip) window.dispatchEvent(new CustomEvent('app-loading', { detail: { type: 'end' } }));
    } catch (e) { }
    try {
      const shouldSkip401Redirect = cfg && (cfg.skipRedirectOn401 === true || (cfg.headers && (cfg.headers['X-Skip-Redirect-On-401'] === '1' || cfg.headers['x-skip-redirect-on-401'] === '1')));
      const isAuthCheck = cfg && (cfg.authCheck === true || (cfg.headers && (cfg.headers['X-Auth-Check'] === '1' || cfg.headers['x-auth-check'] === '1')));
      if (!shouldSkip401Redirect && isAuthCheck && error && error.response && error.response.status === 401) {
        const detail = String(error.response?.data?.detail || error.response?.data?.message || '');
        let msg = 'Your session has expired. Please log in again.';
        if (/inactiv/i.test(detail) || /timeout/i.test(detail)) {
          msg = 'Your session has expired due to 30 minutes of inactivity. Please log in again.';
        } else if (/another device/i.test(detail)) {
          msg = 'Your session has expired because your account was logged in from another device.';
        }
        try { sessionStorage.setItem('session_expired_message', msg); } catch (e) { }
        try { localStorage.removeItem('token'); } catch (e) { }
        try { localStorage.removeItem('user'); } catch (e) { }
        try { localStorage.removeItem('tenant_id'); } catch (e) { }
        try { localStorage.removeItem('login_at'); } catch (e) { }
        try { localStorage.removeItem('last_active_at'); } catch (e) { }
        try { window.location.href = '/'; } catch (e) { window.location.reload(); }
      }
    } catch (e) {
      // swallow errors to avoid masking original axios error
    }
    return Promise.reject(error);
  }
);

export default axios;
